'use client';

import { useEffect, useState } from 'react';
import timezoneNamesAbbreviations from '@/lib/tz-abbr';

function Entry({ timezone, title }: { title: string; timezone: string }) {
  const time = new Date().toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  });

  const [h, m] = time.split(':');

  const [hour, setHour] = useState(h);
  const [minute, setMinute] = useState(m);

  useEffect(() => {
    const interval = setInterval(() => {
      const time = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone,
      });

      const [h, m] = time.split(':');
      setHour(h);
      setMinute(m);
    }, 1000);

    return () => clearInterval(interval);
  }, [timezone]);

  const timezoneName = new Date()
    .toLocaleTimeString('en-US', {
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
      timeZone: timezone,
      timeZoneName: 'long',
    })
    .split(' ')
    .slice(1)
    .join(' ');

  return (
    <li className="flex items-center justify-between border-t border-black/10 pt-3.5 lg:pt-5">
      <span className="font-display medium text-display-2xs text-black/60 uppercase">
        {title}
      </span>
      <span className="text-2xs text-neutral-50">
        {hour}
        <span className="animate-blink">:</span>
        {minute}{' '}
        {timezone === 'Europe/Istanbul'
          ? 'TRT'
          : timezoneNamesAbbreviations[timezoneName]}
      </span>
    </li>
  );
}

export default function Offices({
  offices,
}: {
  offices: NonNullable<PageCareerQueryResult>['locations']['offices'];
}) {
  return (
    <ul className="space-y-2 lg:space-y-5">
      {offices.map((office) => (
        <Entry
          key={office._key}
          title={office.title}
          timezone={office.timezone}
        />
      ))}
    </ul>
  );
}
